import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NewsModel } from 'src/app/models/lobby.model';
import { CasinoService } from 'src/app/service/casino.service';
import { ConstantService } from 'src/app/service/constant.service';
import { GamesService } from 'src/app/service/games.service';
import { HubConnection } from '@microsoft/signalr';
import * as signalR from '@microsoft/signalr';
import { BalaBalanceModel, HubConnectionModel, UserDetail } from 'src/app/models/common.model';
import { TranslateService } from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.styl']
})
export class HeaderComponent implements OnInit, OnDestroy {

  // IsVerified = false;
  IsCallMade = false;
  IsReload = false;
  isNewInfoShow = false;
  isModeChangeTooltip = false;
  gameBalance = 0;
  gameLiability = 0;
  gameId: number;
  gameUrl = '';
  displayMessage = '';
  token = '';
  code = '';
  redirectUrl = '';
  newsList: NewsModel[] = [];
  private balanceInterval: any;
  gameList: any[] = [];
  private liveHubConnection: HubConnection
  private VirtualHubConnection: HubConnection
  hubConnection = new HubConnectionModel();
  virtUaluserDetail = new UserDetail();
  liveUserDetail = new UserDetail();
  currentMode: boolean;
  displayDropdown: boolean = false;
  constructor(
    private casinoService: CasinoService
    , public constant: ConstantService
    , private toastr: ToastrService
    , private router: Router
    , private gameService: GamesService,
    public translateService: TranslateService,
    private domSanitizer: DomSanitizer,
  ) {

    this.constant.gameId = sessionStorage.getItem('GameId') ? JSON.parse(sessionStorage.getItem('GameId')) : 0;
    this.gameUrl = sessionStorage.getItem('GameUrl') ? JSON.parse(sessionStorage.getItem('GameUrl')) : '';
    // console.log(this.gameUrl);
  }
  allLang: { key: string, value: string }[] = [
    { key: 'en', value: 'English' },
    { key: 'gu', value: 'Gujarati' },
    { key: 'hi', value: 'Hindi' },
    { key: 'mr', value: 'Marathi' },
    { key: 'ta', value: 'Tamil' },
    { key: 'te', value: 'Telugu' },
    // { key: 'km', value: 'Kannada' },
    // { key: 'ml', value: 'Malayalam' },
    { key: 'ar', value: 'Arabic' },
    { key: 'cn', value: 'Cantonese' },
    // { key: 'id', value: 'Indonesian' },
    { key: 'ja', value: 'Japanese' },
    { key: 'ko', value: 'Korean' },
    { key: 'ms', value: 'Malay' },
    // { key: 'tl', value: 'Philipino' },
    { key: 'ru', value: 'Russian' },
    { key: 'th', value: 'Thai' },
    { key: 'tb', value: 'Tibetan' },
    // { key: 'vi', value: 'Vietnamese' },
  ];
  // GameCode = '';
  ngOnInit(): void {
    if (location.pathname === '/lobby') {
      let url: any = window.location.href;
      url = url.split('?');
      if (url.length <= 1) {
        sessionStorage.clear();
      }
    }
    const Url = sessionStorage.getItem('GameUrl') ? JSON.parse(sessionStorage.getItem('GameUrl')) : '';
    if (Url) {
      this.constant.GameCode = Url ? new URL(Url).pathname.replace('/', '') : '';
    } else {
      this.constant.GameCode = '';
    }
    window.onbeforeunload = () => { this.ngOnDestroy(); }
    this.constant.newsList = [];
    const url = new URL(window.location.href);
    const Token = url.searchParams.get('Token');
    const Code = url.searchParams.get('Code') || '';
    Token ? this.token = Token : this.token = sessionStorage.getItem('AuthToken');

    this.code = Code;
    if (this.gameUrl) {
      this.gameUrl = this.gameUrl.split('?')[1];
    }
    if ((this.token && this.token !== '' || this.gameUrl)) {
      sessionStorage.setItem('AuthToken', this.token);
      this.getConfig();
    } else {
      this.constant.IsVerified = false;
      this.displayMessage = this.translateService.instant('Invalid Token. Please Login Again');
    }
    this.balanceInterval = setInterval(() => { this.GetBalance(); }, 30 * 1000);
    this.constant.newsList = sessionStorage.getItem('NewsList') ? JSON.parse(sessionStorage.getItem('NewsList')) : [];
    this.constant.isClassicView = sessionStorage.getItem('isNewUI') ? JSON.parse(sessionStorage.getItem('isNewUI')) : true;
    this.currentMode = this.constant.isClassicView;

  }
  private async GetBalance() {
    if (!this.IsCallMade) {
      this.IsCallMade = true;
      const userDetail = new BalaBalanceModel();
      userDetail.LiveClientUserId = this.liveUserDetail.ClientUserId;
      userDetail.VirtualClientUserId = this.virtUaluserDetail.ClientUserId;
      await this.casinoService.GetBalance(userDetail).subscribe(data => {
        this.IsCallMade = false;
        if (data.Status.code === this.constant.HttpResponceCode.Success) {
          // this.constant.IsVerified = true;
          this.constant.getIsVerified.next(this.constant.IsVerified);
          if (data.Balance !== undefined && data.Balance != null) {
            this.constant.balance = Number(data.Balance);
            this.constant.liability = Number(data.Liability);
            if (!this.constant.isIfreameLodded) {
              this.constant.sendData();
            }

          } else {
            this.constant.IsVerified = false;
            this.toastr.error(this.translateService.instant('EC0053'));
            // this.router.navigateByUrl('/lobby?Token=' + this.Token);
            return;
          }
        } else if (data.Status.code === this.constant.HttpResponceCode.Invalid) {
          this.constant.IsVerified = false;
          this.displayMessage = this.constant.TranslateErrorCode(data.Status);
        } else {
          this.constant.IsVerified = false;
          this.displayMessage = this.constant.TranslateErrorCode(data.Status);
          this.toastr.error(this.constant.TranslateErrorCode(data.Status));
          clearInterval(this.balanceInterval);
        }
      }, err => {
        this.onError(err);
      });
    }
  }

  private onError(err) {
    // this.IsCallMade = false;
    this.toastr.error(this.translateService.instant('Somethingwent'));
    // this.router.navigateByUrl('/lobby?Token=' + this.Token);
  }
  async Logout() {
    const url = new URL(window.location.href);
    const Token = url.searchParams.get('Token');
    await this.gameService.logOut().subscribe(data => {
      if (data.Status.code === this.constant.HttpResponceCode.Success) {
        sessionStorage.clear();
        this.constant.balance = 0;
        this.constant.liability = 0;
        this.constant.tmpGameList = [];
        this.constant.gameList = [];
        this.constant.chipsSetting = [];
        this.constant.newsList = [];
        this.constant.userName = '';
        clearInterval(this.balanceInterval);
        this.constant.IsVerified = false;
        if (this.constant.isLobbyShowLive === true || this.constant.isLobbyShowVirtual === true) {
          this.router.navigateByUrl('/lobby');
        }
        this.displayMessage = this.constant.TranslateErrorCode(data.Status);
      } else {
        if (this.constant.isLobbyShowLive === true || this.constant.isLobbyShowVirtual === true) {
          this.router.navigateByUrl('/lobby');
        }
      }
    }, err => {
      this.toastr.error(this.translateService.instant('Somethingwent'));
      if (this.constant.isLobbyShowLive === true || this.constant.isLobbyShowVirtual === true) {
        this.router.navigateByUrl('/lobby?Token=' + Token);
      }
    });
  }
  get isPathGame() {
    return location.pathname === '/games';
  }
  get isround() {
    return location.pathname === '/round';
  }
  get ishistory() {
    return location.pathname === '/history';
  }


  private StartHub() {
    const userDetail = new BalaBalanceModel();
    userDetail.LiveClientUserId = this.liveUserDetail.ClientUserId;
    userDetail.VirtualClientUserId = this.virtUaluserDetail.ClientUserId;
    let liveUserDetail = new UserDetail();
    let virtUaluserDetail = new UserDetail();
    liveUserDetail = JSON.parse(sessionStorage.getItem('LiveuserDetail'));
    virtUaluserDetail = JSON.parse(sessionStorage.getItem('VirtualuserDetail'));
    this.hubConnection = JSON.parse(sessionStorage.getItem('HubConnection'));
    const builder = new signalR.HubConnectionBuilder();
    if (this.hubConnection) {

      this.liveHubConnection = builder.withUrl(this.hubConnection.LiveHubConnection + '/DatabaseSubscriptionHub', {
        transport: signalR.HttpTransportType.LongPolling
      }).build();

      this.VirtualHubConnection = builder.withUrl(this.hubConnection.VirtualConnection + '/DatabaseSubscriptionHub', {
        transport: signalR.HttpTransportType.LongPolling
      }).build();

      this.liveHubConnection.start()
        .then(() => {
          this.joinGroup();
          console.log('Connection started!');
          this.IsReload = false;
        })
        .catch(err => {
          console.error(err);
          if (!this.IsReload) {
            this.StartHub();
            this.IsReload = true;
          } else {
            location.reload();
          }
        });

      this.VirtualHubConnection.start()
        .then(() => {
          this.joinGroup();
          console.log('Connection started!');
          this.IsReload = false;
        })
        .catch(err => {
          console.error(err);
          if (!this.IsReload) {
            this.StartHub();
            this.IsReload = true;
          } else {
            location.reload();
          }
        });

      this.liveHubConnection.onclose((error) => { console.log(error); this.StartHub(); });
      this.VirtualHubConnection.onclose((error) => { console.log(error); this.StartHub(); });

      this.liveHubConnection.on('BalanceChange', (...data) => {
        this.constant.balance = data[2];
        this.getLiability(userDetail);
      });
      this.VirtualHubConnection.on('BalanceChange', (...data) => {
        this.constant.balance = data[2];
        this.getLiability(userDetail);
      });

    }
    else { this.StartHub(); }
  }

  joinGroup() {
    if (this.liveHubConnection) {
      let userDetail = new UserDetail();
      userDetail = JSON.parse(sessionStorage.getItem('LiveuserDetail'));
      if (this.constant.userDetail) {
        this.liveHubConnection.invoke('JoinBalanceChange', userDetail.ClientUserId, userDetail.AgentUserId);
      }
    } else { this.StartHub(); }

    if (this.VirtualHubConnection) {
      let userDetail = new UserDetail();
      userDetail = JSON.parse(sessionStorage.getItem('VirtualuserDetail'));
      if (this.constant.userDetail) {
        this.VirtualHubConnection.invoke('JoinBalanceChange', userDetail.ClientUserId, userDetail.AgentUserId);
      }
    } else { this.StartHub(); }
  }

  ngOnDestroy() {
    let liveUserDetail = new UserDetail();
    let virtUaluserDetail = new UserDetail();
    liveUserDetail = JSON.parse(sessionStorage.getItem('LiveuserDetail'));
    virtUaluserDetail = JSON.parse(sessionStorage.getItem('VirtualuserDetail'));
    this.liveHubConnection.invoke('LeaveBalanceChange', liveUserDetail.ClientUserId, liveUserDetail.AgentUserId);
    this.VirtualHubConnection.invoke('LeaveBalanceChange', virtUaluserDetail.ClientUserId, virtUaluserDetail.AgentUserId);
  }
  getConfig() {
    this.gameService.getConfig().subscribe(data => {
      if (data) {
        this.hubConnection = data.HubConnection;
        this.constant.hubconnection = data.HubConnection;
        // this.constant.userDetail = data.UserDetail;
        sessionStorage.setItem('HubConnection', JSON.stringify(data.HubConnection));
        this.getGameList();
        // sessionStorage.setItem('UserDetail', JSON.stringify(data.UserDetail));
        // this.StartHub();
      }
    })
  }
  getGameList() {
    this.constant.isLobbyShow = true;
    this.gameService.getGameList({ Token: this.token }).subscribe(data => {
      this.constant.isLobbyShow = false;
      if (data.Status.code === 0) {
        this.constant.IsVerified = true;
        this.constant.userName = data.LiveuserDetail.ClientUsername;
        this.constant.balance = data.Balance;
        this.constant.liability = data.Liability;
        // this.constant.FavoriteGames = data.FavoriteGame;
        // GameTypePermission null Means 7
        this.constant.GameTypePermission = data.GameTypePermission ? data.GameTypePermission : 7;
        this.gameList = data.GameList;
        this.constant.gameList = data.GameList;
        this.constant.hedarGameList = data.GameList;
        data.GameList.filter(element => {
          if (element.GameResult != undefined && element.GameResult != null) {
            if (element.GameCode.trim() === "VRPS" || element.GameCode.trim() === "RPS") { element.GameResult = element.GameResult.match(/[^,]+,[^,]+/g); } else { element.GameResult = element.GameResult.split(","); }
          }
        });
        this.constant.tmpGameList = data.GameList;
        this.constant.FavoriteGames = [];
        this.constant.isLobbyShowLive = data.LiveuserDetail.IsShowLobby;
        this.constant.isLobbyShowVirtual = data.VirtualUserDetail.IsShowLobby;
        this.constant.WebsiteURLLive = data.LiveuserDetail.WebsiteURL;
        this.constant.OrderViewLive = JSON.parse(data.LiveuserDetail.OrderView);
        this.constant.WebsiteURLVirtual = data.VirtualUserDetail.WebsiteURL;
        this.constant.OrderViewVirtual = JSON.parse(data.VirtualUserDetail.OrderView);
        if (!this.constant.OrderViewLive || !Array.isArray(this.constant.OrderViewLive) || this.constant.OrderViewLive.length == 0) {
          this.constant.OrderViewLive = [{}];
        }
        if (!this.constant.OrderViewVirtual || !Array.isArray(this.constant.OrderViewVirtual) || this.constant.OrderViewVirtual.length == 0) {
          this.constant.OrderViewVirtual = [{}];
        }
        this.constant.OrderView = Array.from(new Set([...Object.keys(this.constant.OrderViewLive[0]), ...Object.keys(this.constant.OrderViewVirtual[0])])).map(x => ({ [x]: Array.from(new Set([...(this.constant.OrderViewLive[0][x] || []), ...(this.constant.OrderViewVirtual[0][x] || [])])) })).reduce((prev, next) => ({ ...prev, ...next }), {});
        // this.constant.OrderView = Array.from(new Set([...Object.keys(this.constant.OrderViewLive[0]), ...Object.keys(this.constant.OrderViewVirtual[0])]))
        // .map(x => (
        //   { [x]: Array.from(new Set(
        //     [...(this.constant.OrderViewLive[0][x] || []), ...(this.constant.OrderViewVirtual[0][x] || [])]
        //     ))
        //   }
        //   ))
        // .reduce((prev, next) => ({ ...prev, ...next }), {});

        // this.constant.OrderViewGame =  ;
        // var index = array.indexOf(array.filter(function(item) { return item.ID == '200' })[0]);

        // this.constant.OrderViewGame = {};
        Object.keys(this.constant.OrderView).map((key) => {
          if (key != "" && key != undefined) {
            this.constant.OrderView[key].forEach(element => {
              if (element != "" && element != undefined) {
                if (!this.constant.OrderViewGame[key]) {
                  this.constant.OrderViewGame[key] = [];
                }
                this.constant.tmpGameList.map(item => {
                  if (item.GameCode.trim() == element) {
                    this.constant.OrderViewGame[key].push(item);
                  }
                });
              }
            });
          }
        });
        // this.constant.OrderView.forEach(element => {
        //   element.forEach(ele => {
        //     this.constant.tmpGameList.findIndex(e =>{
        //       if(e.GameCode.trim() == ele.trim()){
        //         console.log(ele, e);

        //       }
        //     })
        //   });
        // });


        if (location.pathname === '/lobby' && (this.code == '' || this.code == undefined)) {
          if ((this.constant.isLobbyShowLive == false) || (this.constant.isLobbyShowVirtual == false)) {
            if (this.constant.WebsiteURLLive != '' && this.constant.WebsiteURLLive != null) {
              window.top.location.href = this.constant.WebsiteURLLive;
            } else if (this.constant.WebsiteURLVirtual != '' && this.constant.WebsiteURLVirtual != null) {
              window.top.location.href = this.constant.WebsiteURLVirtual;
            } else {
              this.constant.IsVerified = false;
              this.displayMessage = this.translateService.instant('Invalid Token. Please Login Again');
            }
          }
        }
        this.constant.displayNameLive = data.LiveuserDetail.displayName;
        this.constant.displayNameVirtual = data.VirtualUserDetail.displayName;

        this.liveUserDetail = data.LiveuserDetail;
        this.virtUaluserDetail = data.VirtualUserDetail;

        // this.constant.newsList = data.NewsList;
        this.constant.chipsSetting = data.ChipSetting ? JSON.parse(data.ChipSetting) : this.constant.chipsSetting;
        // this.constant.userDetail = data.UserDetail;
        sessionStorage.setItem('UserName', data.LiveuserDetail.ClientUsername);
        sessionStorage.setItem('GameList', JSON.stringify(this.gameList));
        // sessionStorage.setItem('NewsList', JSON.stringify(data.NewsList));
        sessionStorage.setItem('ChipSetting', data.ChipSetting);
        this.constant.liveUserDetail = data.LiveuserDetail;
        this.constant.virtualUserDetail = data.VirtualUserDetail;
        sessionStorage.setItem('LiveuserDetail', JSON.stringify(data.LiveuserDetail));
        sessionStorage.setItem('VirtualuserDetail', JSON.stringify(data.VirtualUserDetail));
        // sessionStorage.setItem('UserDetail', JSON.stringify(data.UserDetail));
        // this.gameFilterList(fiterTypes.All);
        this.StartHub();
        if (this.code && this.code != '') {
          const gameDetail = this.gameList.find(x => { const code = x.GameCode.trim(); return code === this.code });
          if (gameDetail !== undefined) {
            this.constant.GameCode = this.code.trim();
            this.NavigatoToGame(gameDetail);
          } else {
            this.constant.IsVerified = false;
            this.displayMessage = this.translateService.instant('EC0038');
            // this.toastr.error(this.translateService.instant('EC0038'));
          }
        }
      }
      else {
        this.constant.IsVerified = false;
        this.displayMessage = this.constant.TranslateErrorCode(data.Status);
      }
    }, err => {
      console.log(err);
      this.constant.isLobbyShow = false;
    });
  }

  getLiability(data: BalaBalanceModel) {
    this.gameService.getLiability(data).subscribe((res) => {
      if (res.Liability) {
        this.constant.liability = res.Liability;
        if (!this.constant.isIfreameLodded) {
          this.constant.sendData();
        }
      }
    });
  }

  async NavigatoToGame(item) {
    if (item) {
      // sessionStorage.clear();
      sessionStorage.setItem('GameUrl', JSON.stringify(item.GameUrl));
      sessionStorage.setItem('GameId', JSON.stringify(item.GameID));
      sessionStorage.setItem('GameName', JSON.stringify(item.Name));
      this.constant.gameName = item.Name;
      this.router.navigate(['/games']);

    }
    else {
      sessionStorage.clear();
      sessionStorage.removeItem('GameName');
      this.router.navigate(['/games']);
    }
  }
  homeRedirect() {
    window.top.location.href = this.liveUserDetail.WebsiteURL;
    // if (this.liveUserDetail.IsShowLobby === true || this.virtUaluserDetail.IsShowLobby === true) {
    // }
  }
  ChangeLanguage(value) {
    this.constant.translate.use(value);
    sessionStorage.setItem('Lng', value.trim());
    this.constant.LanguageChange = false;
    setTimeout(() => {
      this.constant.LanguageChange = true;
    }, 1000);
    // var iframereload = document.getElementById('gameIFrame') as HTMLIFrameElement;
    // iframereload.contentWindow.location.reload();
  }
  UserName() {
    if (this.constant.displayNameLive != '' && this.constant.displayNameLive != 'Null' && this.constant.displayNameLive != undefined) {
      return this.constant.displayNameLive;
    } else if (this.constant.displayNameVirtual != '' && this.constant.displayNameVirtual != 'Null' && this.constant.displayNameVirtual != undefined) {
      return this.constant.displayNameVirtual;
    } else if (this.constant.userName != '' && this.constant.userName != 'Null' && this.constant.userName != undefined) {
      return this.constant.userName;
    } else {
      return 'UserName';
    }
  }

  changeView() {
    this.constant.isClassicView = !this.constant.isClassicView;
    this.isModeChangeTooltip = false;
    this.gameUrl = sessionStorage.getItem('GameUrl') ? JSON.parse(sessionStorage.getItem('GameUrl')) : '';
    this.gameUrl = this.constant.ReplaceGameUrl(this.gameUrl);
    sessionStorage.setItem('isNewUI', JSON.stringify(this.constant.isClassicView));
    this.constant.onViewChange.next({ isClassicView: this.constant.isClassicView, gameUrl: this.gameUrl });
    this.currentMode = this.constant.isClassicView;
    // var iframereload = document.getElementById('gameIFrame') as HTMLIFrameElement;
    // // alert(this.gameUrl)
    // // iframereload.contentWindow.location.replace(this.gameUrl)
    // // iframereload.src=this.gameUrl;
    // window.location.reload();
  }
  checkGameStatus(game, index) {
    let gametype = 'Live'
    if (game.Name && (game.Name.includes('Virtual') || game.Name.includes('Rng') || game.Name.includes('RNG'))) {
      gametype = "Virtual";
    }
    let gameDetail = {
      GameCode: game.GameCode.trim(),
      GameType: gametype,
      ClientUsername: this.constant.userName,
    };
    this.gameService.CheckGameStatus(gameDetail).subscribe((data) => {
      let gameDetail = null;
      let GameIndex = 0;
      if (data.data.Code === '1') {
        gameDetail = this.constant.tmpGameList.find(function (item, i) {
          if (item.GameCode.trim() === data.data.GameCode.trim()) {
            GameIndex = i;
            return i;
          }
        });
        this.toastr.error(data.data.ResMessage);
        if (gameDetail != null && gameDetail != undefined && gameDetail != '') {
          this.getGameUrl(gameDetail, GameIndex);
        }
      } else {
        this.getGameUrl(game, index);
      }
    });
  }
  getGameUrl(item, index) {
    // this.constant.isIfreameLodded = true;
    if (!this.constant.isClassicView) {
      if (this.constant.isClassicView == false) {
        item.GameUrl = this.constant.ReplaceGameUrl(item.GameUrl);
        console.log(JSON.parse(JSON.stringify(item.GameUrl)));
      }
    }
    // console.log(JSON.parse(JSON.stringify(item.GameUrl)));
    this.constant.GameCode = item.GameCode;
    this.constant.gameId = item.GameID;
    sessionStorage.setItem('GameIndex', index);
    sessionStorage.setItem('GameName', JSON.stringify(item.Name));
    this.constant.gameName = item.Name;
    
    sessionStorage.setItem('GameUrl', JSON.stringify(item.GameUrl));
    sessionStorage.setItem('GameId', JSON.stringify(item.GameID));
    sessionStorage.setItem('GameIndex', index);
    this.constant.gameName = item.Name;
    this.constant._secureHtml = '';
    setTimeout(() => {
      this.constant._secureHtml = this.domSanitizer.bypassSecurityTrustResourceUrl(item.GameUrl);
    }, 0);


    // console.log(item.Name);
    this.constant.GameChange = false;
    setTimeout(() => {
      this.constant.GameChange = true;
    }, 1000);
    console.log(sessionStorage.getItem('GameUrl'));
  }
}